var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-simple-table',{staticClass:"mt-2"},[[_c('thead',[_c('tr',_vm._l((_vm.titletable),function(title){return _c('th',{key:title,staticClass:"text-left blueLight white--text"},[_vm._v(" "+_vm._s(title)+" ")])}),0)]),_c('tbody',{staticClass:"text-left"},[_vm._t("line")],2)]],2),_c('br')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }